import React, { useContext, useState } from "react";
import { ApiRoutes, FetchContext, HttpMethods } from '../contexts';

export const ApiContext = React.createContext(null);

const { Provider } = ApiContext;
export const ApiProvider = ({ ...props }) => {

    // providers
    const { fetchOk } = useContext(FetchContext);

    const [isLoadingImpostazioni, setIsLoadingImpostazioni] = useState(false);
    const getImpostazioniAsync = async () => {
        try {
            setIsLoadingImpostazioni(true);
            const r = await fetchOk(ApiRoutes.Impostazione.GetImpostazioni(), {
                method: HttpMethods.GET
            });
            const response = await r.json();

            return { data: response };
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingImpostazioni(false);
        }
    }

    return (
        <Provider value={{

            isLoadingImpostazioni,
            getImpostazioniAsync,

        }}>
            {props.children}
        </Provider>
    );
}